import { createElement } from 'react';

var component = function component(props) {
  return createElement("svg", Object.assign({
    xmlns: 'http://www.w3.org/2000/svg',
    viewBox: '0 0 24 24'
  }, props), createElement("g", {
    clipPath: 'url(#a)'
  }, createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M6.5 2h8.2L19 6.3v14.2a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 5 20.5v-17A1.5 1.5 0 0 1 6.5 2Zm10.8 4L15 3.7v1.8a.5.5 0 0 0 .5.5h1.8Zm.2 15h-11a.5.5 0 0 1-.5-.5v-17a.5.5 0 0 1 .5-.5H14v2.5A1.5 1.5 0 0 0 15.5 7H18v13.5a.5.5 0 0 1-.5.5ZM10 15.426v-4.852c0-.445.468-.72.836-.492l3.896 2.427a.585.585 0 0 1 0 .982l-3.896 2.427c-.368.229-.836-.046-.836-.492Z'
  })), createElement("defs", null, createElement("clipPath", {
    id: 'a'
  }, createElement("path", {
    d: 'M0 0h24v24H0z'
  }))));
};

export { component };
//# sourceMappingURL=ItFileVideo-b9b7281e.js.map
